import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Mail, Phone, MapPin } from 'lucide-react';
import { FaWhatsapp, FaLinkedin, FaInstagram, FaTwitter } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/919663112394?text=Hi!%20I%27m%20interested%20in%20getting%20a%20website%20for%20my%20business';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-white" data-testid="footer">
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 font-heading font-bold text-xl mb-4">
              <div className="w-10 h-10 bg-primary-500 rounded-xl flex items-center justify-center">
                <Zap className="w-5 h-5 text-white" />
              </div>
              <span>MakeMyDukaan</span>
            </Link>
            <p className="text-neutral-400 mb-6 leading-relaxed">
              Professional Websites. Built in 48 Hours. Empowering Indian service businesses to own their digital future.
            </p>
            <div className="flex gap-3">
              {[
                { icon: FaWhatsapp, href: WHATSAPP_URL, hoverBg: 'hover:bg-[#25D366]', label: 'WhatsApp' },
                { icon: FaInstagram, href: '#', hoverBg: 'hover:bg-[#E4405F]', label: 'Instagram' },
                { icon: FaLinkedin, href: '#', hoverBg: 'hover:bg-[#0077B5]', label: 'LinkedIn' },
                { icon: FaTwitter, href: '#', hoverBg: 'hover:bg-[#1DA1F2]', label: 'Twitter' }
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 rounded-xl bg-neutral-800 flex items-center justify-center ${social.hoverBg} transition-colors`}
                  data-testid={`footer-${social.label.toLowerCase()}-link`}
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-lg mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'About Us', path: '/about' },
                { name: 'Our Work', path: '/#examples' },
                { name: 'Pricing', path: '/#pricing' },
                { name: 'Contact', path: '/contact' },
                { name: 'Blog', path: '#' }
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path.startsWith('/#') ? '/' : link.path}
                    className="text-neutral-400 hover:text-primary-300 transition-colors"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-lg mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:hello@makemydukaan.in" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-email">
                  hello@makemydukaan.in
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+919663112394" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-phone">
                  +91 96631 12394
                </a>
              </li>
              <li className="flex items-start gap-3">
                <FaWhatsapp className="w-5 h-5 text-[#25D366] mt-0.5 flex-shrink-0" />
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-whatsapp">
                  WhatsApp: +91 96631 12394
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
                <span className="text-neutral-400">Bangalore, India</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-lg mb-5">All Plans Include</h4>
            <ul className="space-y-3">
              {['Unlimited revisions', '48-hour delivery', 'Free hosting & SSL', '24/7 uptime monitoring', 'WhatsApp integration'].map((item) => (
                <li key={item} className="flex items-center gap-2 text-neutral-400">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            &copy; {currentYear} MakeMyDukaan. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-neutral-500 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-neutral-500 hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
